import Api from 'libs/api/index';

class ShoppingCenters extends Api {
  constructor() {
    super('shopping_centers/');
  }

  getVacancies(shoppingCenterCode) {
    return this.buildQuery('get', {}, `${shoppingCenterCode}/vacancies`);
  }
}

export default ShoppingCenters;
